import { IconWarningRegular, skinVars, Spinner, Stack, Text3, useDialog } from '@telefonica/mistica';
import { AxiosError, AxiosResponse } from 'axios';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { loginSSO } from '../../services/LoginService';

const SSOAJX4: React.FC = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const { dialog } = useDialog();
    const jwe = params.get('jwe');
    const redirectUri = params.get('redirectUri') || '';

    useEffect(() => {
        try {
            new URL(redirectUri);
            loginSSO({
                jwe: jwe,
            })
                .then((response: AxiosResponse) => {
                    window.location.href = redirectUri;
                })
                .catch((error: AxiosError) => {
                    window.location.href = `${redirectUri}?error=${error}`;
                });
        } catch (_) {
            dialog({
                icon: <IconWarningRegular color={skinVars.colors.feedbackErrorBackground} size={53} />,
                title: t('genericErrorTitle'),
                message: (() => {
                    return (
                        <Stack space={16}>
                            <Text3 light color={skinVars.colors.textSecondary}>
                                {t('errorGenericDescription')}
                            </Text3>
                        </Stack>
                    );
                })() as any,
                onAccept() {},
                acceptText: t('buttonUnderstoodFeedback'),
            });
            return;
        }
    }, []);

    return (
        <>
            <div className='c-spinner'>
                <Spinner size={24} />
                <span className='c-spinner-overlay'></span>
            </div>
        </>
    );
};

export default SSOAJX4;
